import { Upload } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import Swal from "sweetalert2";
import { useSelector } from "react-redux";
import { useRef, useState } from "react";
import { uploadToS3 } from "../utils/s3";

const UploadButton = ({ onChange, disabled }) => {
  const accessToken = useSelector((state) => state.user.accessToken);

  const [uploading, setUploading] = useState(false);
  const requestCountRef = useRef(0);
  const resetTimeoutRef = useRef(null);

  const uploadFile = async (file) => {
    try {
      return await uploadToS3(file, accessToken); // S3 key, stored in the DB
    } catch (error) {
      console.error("Error uploading file:", error);
      Swal.fire(
        "Upload failed",
        "File upload failed. Please try again.",
        "error"
      );
      return null;
    }
  };

  const handleImageChange = async ({ file }) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      Swal.fire(
        "Invalid file type",
        "You can only upload JPG/PNG files.",
        "error"
      );
      return;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      Swal.fire("File too large", "Image must be smaller than 2MB.", "error");
      return;
    }

    if (requestCountRef.current >= 10) {
      Swal.fire(
        "Limit exceeded",
        "Maximum 10 uploads every 40 seconds.",
        "warning"
      );
      return;
    }

    requestCountRef.current++;
    setUploading(true);
    const uploadedImageURL = await uploadFile(file.originFileObj || file);
    setUploading(false);
    if (uploadedImageURL) {
      onChange(uploadedImageURL);
    }

    if (!resetTimeoutRef.current) {
      resetTimeoutRef.current = setTimeout(() => {
        requestCountRef.current = 0;
        resetTimeoutRef.current = null;
      }, 40000);
    }
  };

  return (
    <Upload
      maxCount={1}
      showUploadList={false}
      onChange={handleImageChange}
      beforeUpload={() => false}
      disabled={disabled || uploading}
      className="upload-button-wrapper"
    >
      <div className="choose-photo-button">
        {uploading ? (
          <>
            <LoadingOutlined spin style={{ marginRight: 8 }} />
            Uploading...
          </>
        ) : (
          "Choose photo"
        )}
      </div>
    </Upload>
  );
};

export default UploadButton;

// Add these CSS styles
const styles = `
.upload-button-wrapper {
    position: relative;
    display: inline-block;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
}

.choose-photo-button {
    padding: 8px 24px;
    border: 1px solid #3371EB;
    border-radius: 4px;
    color: #3371EB;
    background-color: rgba(255, 255, 255, 0.7);
    font-size: 16px;
        cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
}

.choose-photo-button:hover {
    background-color: #3371EB;
    color: white;
    opacity: 0.8;
}

.upload-button-wrapper.disabled .choose-photo-button {
    background-color: #f5f5f5;
    border-color: #d9d9d9;
    color: rgba(0, 0, 0, 0.25);
    cursor: not-allowed;
}
`;

// Inject styles
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);
